<style scoped>
.notification-container {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 40vh;
}
.pull-right {
  float: right;
}
</style>

<template>
  <mu-menu :open.sync="open">
    <mu-button flat>
      <mu-icon value="history"></mu-icon>
    </mu-button>
    <div slot="content" ref="scroll" class="notification-container">
      <mu-list textline="two-line">
        <mu-sub-header>{{$t('history.title')}}</mu-sub-header>
        <mu-list-item avatar button :ripple="false" v-for="item in items" :to="item.path">
          <mu-list-item-action>
            <mu-avatar>
              <mu-icon :value="iconType(item)"></mu-icon>
            </mu-avatar>
          </mu-list-item-action>
          <mu-list-item-content>
            <mu-list-item-title>{{item[item.type]['name']}}</mu-list-item-title>
            <mu-list-item-sub-title>{{stringTime(item.created_at)}}</mu-list-item-sub-title>
          </mu-list-item-content>
        </mu-list-item>
      </mu-list>
    </div>
  </mu-menu>
</template>

<script>

// Library
import axios from "axios";

export default {
  name: 'HistoryPanel',
  components: {
    
  },
  props: {

  },
  data() {
    return {
      items: [],
      last: 5,
      scrolled: false,
      open: false,
      interval: null,
    }
  },
  computed: {
    authorized() {
      return this.$store.state.auth.authorized;
    },
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },
    scroll() {
      return this.$refs.scroll;
    },
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
  },
  mounted() {
    this.getData();
    this.interval = setInterval(this.getData, 60000);
    this.scroll.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    authorized(newValue) { // Watch on authorized
      if(newValue) {
        this.getData()
      }
    },
    triggerRefresh() {
      this.getData()
    },
  },
  methods: {
    getData() {
      axios.get(this.$store.getters.urlApi + "history?take=" + this.last, {
        headers: {
          token: this.$store.state.auth.token
        }
      })
      .then(res => {
        this.items = [];
        res.data.data.histories.forEach((item, index) => {
          this.items[index] = item;
        })
      });
    },
    handleScroll() {
      this.scrolled = Math.ceil(this.scroll.scrollTop) >= this.scroll.scrollHeight - this.scroll.offsetHeight;
      if (this.scrolled) {
        this.last += 5;
        this.getData();
      }
    },

    stringTime(time) {
      var d = new Date(time);
      const myTimeZone = 8;
      d.setTime( d.getTime() + myTimeZone * 60 * 60 * 1000 );
      var delta = Math.round((+new Date - d) / 1000);
      var minute = 60,
        hour = minute * 60,
        day = hour * 24,
        week = day * 7,
        month = day * 30,
        year = day * 356;
      var str = "";
      if (delta < 30) {
        str += this.$t('time.justNow');
      } else if (delta < minute) {
        str += delta + this.$t('time.secondsAgo');
      } else if (delta < 2 * minute) {
        str += this.$t('time.minuteAgo');
      } else if (delta < hour) {
        str += Math.floor(delta / minute) + this.$t('time.minutesAgo');
      } else if (Math.floor(delta / hour) == 1) {
        str += this.$t('time.hourAgo');
      } else if (delta < day) {
        str += Math.floor(delta / hour) + this.$t('time.hoursAgo');
      } else if (delta < day * 2) {
        str += this.$t('time.yesterday');
      } else if (delta < day * 7) {
        str += Math.floor(delta / day) + this.$t('time.daysAgo');
      } else if (delta < month) {
        str += Math.floor(delta / week) + this.$t('time.weeksAgo');
      } else if (delta < year) {
        str += Math.floor(delta / month) + this.$t('time.monthsAgo');
      } else {
        str += Math.floor(delta / year) + this.$t('time.yearsAgo');
      }
      return str;
    },
    iconType(item) {
      if(item.type === 'channel') {
        return 'subscriptions';
      } else if(item.type === 'media') {
        return this.iconMediaType(item.media.type);
      } else {
        return '';
      }
    },
    iconMediaType(type) {
      if(type == "video") {
        return 'movie';
      } else if(type == "img") {
        return "photo";
      } else if(type == "pdf") {
        return "insert_drive_file";
      } else if(type == "youtube") {
        return 'subscriptions';
      } else if(type == "wysiwyg") {
        return "text_format";
      } else if(type == "mp4link") {
        return "on_demand_video";
      } else if(this.isModelType(type) || type == 'model') {
        return 'layers';
      }
    },
    isModelType(type) {
      var array = ["stl", "obj", "three", "collada", "ply", "gltf"];
      return array.includes(type);
    },
  },
  destroyed() {
    this.scroll.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.interval);
  }

}
</script>
